import { Link } from "react-router-dom";
import { useUserStore } from "@/store/user/userStore";
import styles from "../../Navigation.module.css";

const StaffNav = () => {
  const canAccessManagement = useUserStore((state) => state.canAccessManagement);

  return (
    <>
      <Link to={"/history/staff"} className={styles.navLink}>
        Borrowing History
      </Link>
      <Link to={"/usermanagement"} className={styles.navLink}>
        User Management
      </Link>
      <Link to={"/insertborrowing"} className={styles.navLink}>
        Insert Borrowing
      </Link>
      <Link to={"/report"} className={styles.navLink}>
        Report
      </Link>
      <Link to={"/feedback"} className={styles.navLink}>
        Feedback
      </Link>
      {canAccessManagement && (
        <Link to={"/management"} className={styles.navLink}>
          Room Management
        </Link>
      )}
    </>
  );
};

export default StaffNav;
